import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, Data } from '@angular/router';

import { Session } from '../services/session';
import { Role } from '../lib/roles.const';

export interface IRoleGuardConfig {
  role: Role;
  redirectTo: string;
}

@Injectable()
export class RoleGuard {
  constructor(
    private session: Session,
    private router: Router,
  ) {
    this.session = session;
    this.router = router;
  }

  public canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot): boolean {
    return this.isRouteAccessible(activatedRouteSnapshot.data);
  }

  public canLoad(activatedRouteSnapshot: ActivatedRouteSnapshot): boolean {
    return this.isRouteAccessible(activatedRouteSnapshot.data);
  }

  private isRouteAccessible(data: Data) {
    const config: IRoleGuardConfig = data.roleGuard;
    if (config.role === Role.DRIVER && this.session.isDriver()) return true;
    if (config.role === Role.DISPATCHER && this.session.isDispatcher()) return true;
    if (config.role === Role.ADMIN && this.session.userPermissions.hasAdministrativePermission()) return true;

    this.router.navigate([config.redirectTo]);
    return false;
  }
}
